import { LandmarkIcon } from "lucide-react";

import { FinancialInstitutionFragment } from "@/__generated__/graphql";
import { iconsByTypename } from "@/objects/@icons";
import { ObjectType } from "@/objects/@types";
import { getReferenceValueOptionsByTypename } from "@/objects";

const object: ObjectType<FinancialInstitutionFragment> = {
  humanName: "institution",
  typename: "FinancialInstitutionObject",
  report: {
    source: "financial_institutions",
    description: "The banks the accounts are held at",
    asks: "How much is held at each bank?",
  },
  ReactIcon: LandmarkIcon,
  isEntity: false,
  titleFieldKey: "institutionName",
  getTitle: (data) => data?.institutionName ?? "",
  // An institution has no entity of its own on the fragment — it is reachable
  // through the accounts held there, which all belong to the same entity.
  getEntityId: (data) =>
    data?.financialAccounts?.[0]?.financialInstitution?.entity?.id,
  fieldDefinitions: [
    {
      objectKey: "institutionName",
      label: "Name",
      type: "text",
      ReactIcon: LandmarkIcon,
      asString: (data) => data?.institutionName ?? "",
      getValue: (data) => data?.institutionName ?? "",
      // Institutions come from the provider; nothing here is ours to edit.
      updateProps: {
        isEditable: false,
        isRequired: false,
      },
      createProps: {
        isRequired: true,
      },
      summaryProps: {
        isVisible: true,
      },
    },
    {
      objectKey: "financialAccounts",
      label: "Accounts",
      type: "references",
      ReactIcon: iconsByTypename.FinancialAccountObject,
      asString: (data) =>
        (data?.financialAccounts ?? [])
          .map((account) => account.name)
          .filter(Boolean)
          .join(", "),
      getValue: (data) =>
        (data?.financialAccounts ?? []).map((account) => ({
          __typename: account.__typename ?? "FinancialAccountObject",
          id: account.id,
          identifier: account.identifier,
          name: account.name ?? account.identifier,
        })),
      getValueOptions: () =>
        getReferenceValueOptionsByTypename("FinancialAccountObject")(),
      updateProps: {
        isEditable: false,
        isRequired: false,
      },
      summaryProps: {
        isVisible: true,
      },
    },
  ],
};

export { object as FinancialInstitutionObject };
